import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';

import { saveConfig, updateSelectedOptions } from '../../FilterActions';
import { CustomMultiselect, MemberItemRenderer } from '../common';

class LocalMembers extends Component {
  constructor(props) {
    super(props);
    this.state = {
      items: [],
      selectedItems: [],
    };

    this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount() {
    this.updateState();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.items != this.props.items) {
      this.setState({
        items: this.props.items,
      });
    }

    if (prevProps.selectedItems != this.props.selectedItems) {
      this.setState({
        selectedItems: this.props.selectedItems,
      });
    }
  }

  updateState() {
    this.setState({
      items: this.props.items,
      selectedItems: this.props.selectedItems,
    });
  }

  handleChange(selected) {
    this.props.updateSelectedOptions(selected);
    this.props.saveConfig();
  }

  render() {
    const { items, selectedItems } = this.state;

    return (
      <CustomMultiselect
        name={'Members'}
        items={items}
        selectedItems={selectedItems}
        onSelect={this.handleChange}
        itemRenderer={MemberItemRenderer}
      />
    );
  }
}

LocalMembers.propTypes = {};

const mapDispatchToProps = (dispatch) => {
  return {
    saveConfig: () => dispatch(saveConfig()),
    updateSelectedOptions: (vals) => dispatch(updateSelectedOptions('members', vals)),
  };
};

const mapStateToProps = (state) => {
  let chart = state.filters.chart;
  return {
    items: state.filters.allMembers,
    selectedItems: state.filters[chart].selectedMembers,
  };
};

const connected = connect(mapStateToProps, mapDispatchToProps)(LocalMembers);
export { connected as LocalMembers };
